import { seatAfter } from "../core/trick";
import { at } from "../core/util";
export const PENALTIES = [
    "noTricks",
    "noHearts",
    "noBoys",
    "noQueens",
    "lastTwo",
    "rifki",
];
/** What a penalty game charges, per trick or per card (review 0026 S3). */
export const PENALTY_POINTS = {
    noTricks: -50,
    noHearts: -30,
    noBoys: -60,
    noQueens: -100,
    lastTwo: -180,
    rifki: -320,
};
export const TRUMP_TRICK_POINTS = 50;
/** Each penalty game is played at most twice in a match, whoever chooses it. */
export const PENALTY_LIMIT = 2;
export const LENGTH_OPTIONS = [20, 12];
export const DEFAULT_LENGTH = 20;
/** How often a seat may choose each kind: 2 + 3 over 20 hands, 1 + 2 over 12 (decision 188). */
export function quotaFor(length) {
    return length === 12 ? { trumps: 1, penalties: 2 } : { trumps: 2, penalties: 3 };
}
export class KingError extends Error {
    code;
    constructor(code) {
        super(code);
        this.name = "KingError";
        this.code = code;
    }
}
export const FIRST_CHOOSER = 1;
export function nextChooser(chooser) {
    return seatAfter(chooser);
}
/** Seat expected to act: the chooser while the game is named, then whoever plays next. */
export function currentActor(state) {
    if (state.phase === "choosing")
        return state.chooser;
    if (state.phase !== "playing" || state.trick.winner !== null)
        return null;
    return seatAfter(state.trick.leader, state.trick.plays.length);
}
/** What a seat may still choose: its own rights, and the penalty games the table has left. */
export function rightsOf(state, seat) {
    const quota = quotaFor(state.length);
    return {
        trumps: quota.trumps - at(state.chosen.trumps, seat),
        penalties: quota.penalties - at(state.chosen.penalties, seat),
    };
}
export function penaltiesLeft(state) {
    const left = {};
    for (const penalty of PENALTIES)
        left[penalty] = PENALTY_LIMIT - state.played[penalty];
    return left;
}
//# sourceMappingURL=state.js.map